import { WaypointArrivalDelayReason } from '@caresend/types';
import { defineComponent } from 'vue';
import __vue_component__ from '../../alerts/Alert.vue.js';
import __vue_component__$1 from '../../buttons/ButtonComponent/ButtonComponent.vue.js';

const delayReasons = {
    [WaypointArrivalDelayReason.LEFT_TOO_LATE]: 'I left too late',
    [WaypointArrivalDelayReason.UNABLE_TO_ACCESS_LOCATION]: 'Unable to access location',
    [WaypointArrivalDelayReason.ISSUES_WITH_DRIVING_INSTRUCTIONS]: 'Issues with driving instructions',
    [WaypointArrivalDelayReason.PARKING_ISSUES]: 'Parking issues',
    [WaypointArrivalDelayReason.LACK_OF_SIGNAL]: 'Lack of signal/reception',
    [WaypointArrivalDelayReason.TECH_ISSUES]: 'Tech issues',
    [WaypointArrivalDelayReason.OTHER]: 'Other',
};
var script = defineComponent({
    /** Capture why the clinician is too late to the scheduled waypoint time */
    name: 'LateArrivalReasonModal',
    components: {
        Alert: __vue_component__,
        ButtonComponent: __vue_component__$1,
    },
    props: {
        isOpened: Boolean,
    },
    setup(_props, { emit }) {
        const captureDelayReason = (reason) => {
            emit('selectDelayReason', reason);
        };
        return {
            captureDelayReason,
            delayReasons,
        };
    },
});

export { script as default };
